"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFont = void 0;

var react_1 = __importDefault(require("react"));

var react_2 = require("@emotion/react");

function IconFont() {
  return react_1.default.createElement(react_2.Global, {
    styles: (0, react_2.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        @font-face {\n          font-family: 'themify';\n          src: url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.eot?-fvbane');\n          src: url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.eot?#iefix-fvbane')\n              format('embedded-opentype'),\n            url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.woff?-fvbane')\n              format('woff'),\n            url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.ttf?-fvbane')\n              format('truetype'),\n            url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.svg?-fvbane#themify')\n              format('svg');\n          font-weight: normal;\n          font-style: normal;\n        }\n      "], ["\n        @font-face {\n          font-family: 'themify';\n          src: url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.eot?-fvbane');\n          src: url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.eot?#iefix-fvbane')\n              format('embedded-opentype'),\n            url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.woff?-fvbane')\n              format('woff'),\n            url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.ttf?-fvbane')\n              format('truetype'),\n            url('https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/fonts/themify.svg?-fvbane#themify')\n              format('svg');\n          font-weight: normal;\n          font-style: normal;\n        }\n      "])))
  });
}

exports.IconFont = IconFont;
var templateObject_1;